import { useTranslation } from "react-i18next";

import { useRequiredContext } from "@lib/utils";

import { HaNResultList } from "../shared/HaNResultList/HaNResultList";
import { HaNContext } from "../shell/HaNContext";
import { PeopleOnFloor } from "./components/PeopleOnFloor";
import { PeopleOnOtherFloors } from "./components/PeopleOnOtherFloors";
import { usePeopleModel } from "./usePeopleModel";

export const PeopleList = () => {
  const { tab } = useRequiredContext(HaNContext);

  if (tab !== "people") return null;

  return <PeopleListContent />;
};

const PeopleListContent = () => {
  const { t } = useTranslation();
  const { isLoading, isFailed, retry, onSelectedFloor, otherFloors } = usePeopleModel();

  if (isLoading) return <HaNResultList.Loading />;
  if (isFailed) {
    return (
      <HaNResultList.Error
        text={t("hereAndNow:PeopleLoadFailed")}
        onRetry={retry}
      />
    );
  }
  if (onSelectedFloor.length === 0 && otherFloors.length === 0) {
    return <HaNResultList.Empty text={t("hereAndNow:NobodyInBuilding")} />;
  }

  return (
    <>
      <PeopleOnFloor people={onSelectedFloor} />

      <PeopleOnOtherFloors floors={otherFloors} />
    </>
  );
};
